<template>
  <div
    class="row-1 editorial-double-columns-general"
    :class="{
      '--double-on-small': content.doubleColumn.includes('si'),
    }"
  >
    <div
      class="editorial-double-columns-general__column"
      v-if="props.content.contentText1"
    >
      <div
        class="text text-editorial"
        v-html="props.content.contentText1"
      ></div>
    </div>
    <div
      class="editorial-double-columns-general__column"
      v-if="props.content.contentText2"
    >
      <div
        class="text text-editorial"
        v-html="props.content.contentText2"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EditorialGalleryGeneral',
}
</script>

<script setup>
const props = defineProps({
  content: Object,
})
</script>

<style lang="scss">
@import './style.scss';
</style>
